// Layout Types
import Landing from '../Landing';
import PublicLayout from '../layout/PublicLayout';
import ViewProfile from '../customer/viewProfile/ViewProfile';
import CategoryDetails from '../customer/categoryDetails/CategoryDetails';
import LoginAs from '../modals/loginAs/LoginAs';
import MasterLogin from '../modals/masterSignUp/MasterSignUp';
import AdminLayout from '../layout/AdminLayout';

// Route Views

const publicRoutes = [
    {
        path: '/',
        exact: true,
        layout: PublicLayout,
        component: <Landing />

    },
    {
        path: "/consumer/viewprofile",
        exact: true,
        layout: PublicLayout,
        component: <ViewProfile />,
    },
    {
        path: "/consumer/categorydetails",
        exact: true,
        layout: PublicLayout,
        component: <CategoryDetails />,
    },
    {
        path: "/login",
        exact: true,
        layout: PublicLayout,
        component: <LoginAs />,
    },
    {
        path: "/master-login",
        exact: true,
        layout: AdminLayout,
        component: <MasterLogin />,
    },
];

export default publicRoutes;
